export default {
  "news.detail.pageTitle": "ニュース",

  "news.detail.head.siteName": "LINK-J",

  "news.list.head.title": "ニュース",
  "news.list.head.description": "LINK-Jの最新ニュースをお知らせいたします。",
  "news.list.head.siteName": "LINK-J",
  "news.list.title": "ニュース",
  "news.list.heading.title": "ニュース一覧",

  "news.categories.topics": "トピック",
  "news.categories.press-release": "プレスリリース",
  "news.categories.media": "メディア情報",
  "news.categories.overseas": " 海外関連",
  "news.categories.program": "アクセラレーション",
  "news.categories.news-events": "イベント告知",
  "news.categories.sponsorship": "協賛・協力",
  "news.categories.facilities": "施設",
  "news.categories.index": "ニュース一覧",

  "news.bbt.detail.pageTitle": "ニュース",

  "news.bbt.detail.head.siteName": "Blockbuster TOKYO",

  "news.bbt.list.head.title": "ニュース一覧（BBT） | LINK-J",
  "news.bbt.list.head.description":
    "創薬・医療領域のスタートアップ支援・コミュニティ活性化｜Blockbuster TOKYO ニュース",
  "news.bbt.list.head.siteName": "Blockbuster TOKYO",
  "news.bbt.list.title": "ニュース一覧（BBT） | LINK-J",
  "news.bbt.list.heading.title": "ニュース一覧",

  "news.bbt.list.index.breadcrumbs": "ニュース一覧",
  "news.archive.list.title": "年代別",
} as const;
